import { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

export default class Base extends Component {
  static contextTypes = {
    _register: PropTypes.func.isRequired,
    _unregister: PropTypes.func.isRequired,
    _setProps: PropTypes.func.isRequired,
    _handleChange: PropTypes.func.isRequired,
    _handleBlur: PropTypes.func.isRequired,
    _getProps: PropTypes.func.isRequired
  };

  static propTypes = {
    validations: PropTypes.arrayOf(PropTypes.func)
  };

  static defaultProps = {
    validations: []
  };

  constructor(props) {
    super(props);
    this.id = uuidv4();
  }

  componentDidMount() {
    this.context._register(this, this.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.context._setProps(nextProps, this.id);
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextContext !== this.context;
  }

  componentWillUnmount() {
    this.context._unregister(this, this.id);
  }

  handleChange = (event) => {
    event.persist();
    return this.context._handleChange(event, this.id, this.props);
  };

  handleBlur = (event) => {
    event.persist();
    this.context._handleBlur(event, this.id);
  };

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/react-validation/components/base/index.js